
import { ProductItem } from "../style"

import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import SwiperCore, {
    Navigation, Autoplay
} from 'swiper';
import { Link } from "react-router-dom";
import { toProduct } from "../../helper/paths";
const Index = ({ item, ...props }) => {

    return <ProductItem {...props} className="top-product-item" href="#">
        <div className="top-product-item-front">
            {
                item.in_stock === 0 ? < div className="product-status status-out"><span>Out Of Stock</span></div>
                    : ''
            }
            <Swiper
                style={{ '--swiper-navigation-color': '#fff', '--swiper-pagination-color': '#fff' }}
                spaceBetween={0}
                navigation={false}
                className="product-slider"
                watchSlidesProgress
                slidesPerView={1}
                autoplay={{ delay: 3000 }}
            >
                {
                    item.images ?
                        [{ image_thumb_path: item.image_thumb_path }, ...item.images].map((img, index) =>
                            <SwiperSlide key={index} >
                                <div >
                                    <img src={img.image_thumb_path} alt="" />
                                </div>
                            </SwiperSlide>
                        ) : ''
                }
            </Swiper>
            <div className="product-item-line"></div>
            <h3 className="product-item-title">{item.brand ? item.brand.title : ''}</h3>
        </div>
        <div className="top-product-item-back">
            <Link to={toProduct(item.slug)} style={{ display: 'block' }}>
                <div className="short-desc mb-2" dangerouslySetInnerHTML={{ __html: item.title }} />
                <div className="product-item-price">{item.price_currency}</div>
            </Link>
        </div>
    </ProductItem>
}

export default Index